module.exports = __webpack_public_path__ + "media/checkout/apple-5a9199bf.svg";